import { CONNECT_PATH } from "../constants";

export const getPublicImagePath = (imgUrl: string) => {
  const isProduction = process.env.NODE_ENV === "production";
  const connectPath = isProduction ? CONNECT_PATH : "";
  return `${connectPath}/images/${imgUrl}`;
};
